import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AssignmentFormGroup } from './assignment-form-group.interface';
import { Injectable, inject } from '@angular/core';
import { AssignmentStatuses } from 'src/app/core/enums/assignment-statuses.enum';
import { AssignmentPriorities } from 'src/app/core/enums/assignment-priorities.enum';

@Injectable()
export class AssignmentFormModel {
  private formBuilder = inject(FormBuilder);

  readonly fieldNames = {
    title: 'title',
    description: 'description',
    deadline: 'deadline',
    status: 'status',
    priority: "priority"
  };

  form: FormGroup<AssignmentFormGroup>;

  constructor() {
    this.form = this.initForm();
  }

  private initForm(): FormGroup<AssignmentFormGroup> {
    return this.formBuilder.group<AssignmentFormGroup>({
      title: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(128)],
        nonNullable: true,
      }),
      description: new FormControl(null),
      deadline: new FormControl(null),
      status: new FormControl(AssignmentStatuses.New, { nonNullable: true }),
      priority: new FormControl(AssignmentPriorities.Middle, { nonNullable: true }),
    });
  }
}
